import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=7158ae5a&scoped=true&"
import script from "./compare.vue?vue&type=script&lang=js&"
export * from "./compare.vue?vue&type=script&lang=js&"
import style0 from "./compare.vue?vue&type=style&index=0&id=7158ae5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7158ae5a",
  null
  
)

export default component.exports